import React, { useState, useEffect } from "react";
import { Card, Typography } from "@material-tailwind/react";
import Popup from "reactjs-popup";
import "../../../../styles/popup.css";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import API from "../../../../utils/API";
import CustomTable from "../../../DynamicComponents/CustomTable";
import ExperiencePopUp from "../PopUp/ExperiencePopUp";

const Experience = ({ setBlurActive }) => {
  const [experienceData, setExperienceData] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [isAddExperience, setIsAddExperience] = useState(false);
  const user = useSelector((state) => state.auth.user) || {};
  const { user_id, department_id } = user;

  const fetchExperienceData = async () => {
    try {
      const response = await API.get(
        `/${department_id}/alumni/experience?user_id=${user_id}`
      );
      const data = response?.data || [];
      setExperienceData(data);
    } catch (error) {
      toast.error(
        error?.response?.data?.error || "Error communicating with server"
      );
    }
  };

  useEffect(() => {
    if (!user_id) return;
    fetchExperienceData();
  }, [user_id]);

  const openPopup = (experience = null) => {
    setSelectedExperience(experience);
    setPopupOpen(true);
    setBlurActive(true);
    setIsAddExperience(!experience);
  };

  const closePopup = () => {
    setPopupOpen(false);
    setBlurActive(false);
    setSelectedExperience(null);
    setIsAddExperience(false);
  };

  const handleSaveExperience = async (experience) => {
    try {
      let response;
      if (isAddExperience) {
        response = await API.post(
          `/${department_id}/alumni/experience`,
          experience,
          {
            params: { user_id },
          }
        );
      } else {
        response = await API.put(
          `${department_id}/alumni/experience/${selectedExperience.exp_id}`,
          experience
        );
      }

      if (response?.data) {
        toast.success(
          `Experience ${isAddExperience ? "added" : "updated"} successfully`
        );
        fetchExperienceData();
        closePopup();
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error ||
          `Error ${isAddExperience ? "adding" : "updating"} experience`
      );
    }
  };

  const handleDeleteExperience = async (exp_id) => {
    try {
      const response = await API.delete(
        `${department_id}/alumni/experience/${exp_id}`
      );
      if (response?.data) {
        toast.success("Experience deleted successfully");
        setExperienceData(
          experienceData.filter((exp) => exp.exp_id !== exp_id)
        );
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Error deleting experience");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Present";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
    });
  };

  const tableData = experienceData.map((exp) => ({
    ...exp,
    start_date: formatDate(exp.start_date),
    end_date: exp.currently_working ? "Present" : formatDate(exp.end_date),
  }));

  return (
    <>
      <CustomTable
        title="Work Experience"
        subtitle="Your professional work history"
        columns={[
          { key: "title", label: "Job Title" },
          { key: "company", label: "Company" },
          { key: "location", label: "Location" },
          { key: "start_date", label: "Start Date" },
          { key: "end_date", label: "End Date" },
          { key: "actions", label: "Actions" },
        ]}
        data={tableData}
        actions={{
          edit: (experience) => openPopup(experience),
          delete: (experience) => handleDeleteExperience(experience.exp_id),
        }}
        onAdd={() => openPopup()}
      />

      <Popup
        open={isPopupOpen}
        onClose={closePopup}
        className="mx-auto my-auto p-2"
        closeOnDocumentClick
      >
        <div>
          <ExperiencePopUp
            experience={selectedExperience}
            closeModal={closePopup}
            handleSaveExperience={handleSaveExperience}
            isAddMode={isAddExperience}
          />
        </div>
      </Popup>
    </>
  );
};

export default Experience;
